/**
 * Tongan paʻanga.
 */
export var TOP = {
  code: 'TOP',
  base: 10,
  exponent: 2
};